var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8857 0.0136719C16.3563 0.290767 20.707 4.81409 20.707 10.3535L20.6934 10.8857C20.5934 12.8595 19.9376 14.6854 18.8838 16.2158L22.6123 19.8525C23.3753 20.597 23.3826 21.8213 22.6289 22.5752C21.8881 23.316 20.6894 23.3233 19.9395 22.5918L16.1699 18.915C14.5117 20.0439 12.5107 20.707 10.3535 20.707L9.82031 20.6934C4.52638 20.4249 0.281853 16.1797 0.0136719 10.8857L0 10.3535C0 4.63554 4.63551 0 10.3535 0L10.8857 0.0136719ZM10.3535 3.40039C6.51326 3.40039 3.40039 6.51332 3.40039 10.3535C3.4005 14.1936 6.51333 17.3066 10.3535 17.3066C14.1936 17.3066 17.3065 14.1936 17.3066 10.3535C17.3066 6.51337 14.1937 3.40047 10.3535 3.40039Z",
    fill: "#525252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.38ba4b32c51413881023cc449b036c4e.svg";
export { ForwardRef as ReactComponent };